import {authConfig} from 'lib/auth-config';
import {OktaAuth} from '@okta/okta-auth-js';

export {describeAuthError, isAnonymousAuth} from 'services/auth-errors';

export const oktaAuth = new OktaAuth({...authConfig});
